import { CreateAllModal } from "./CreateAllModal";

export default CreateAllModal;
